






import { Component, Vue, Prop, Watch, Provide } from "vue-property-decorator";

export interface IFleetData {
  activeIndex: number;
  activeVessel: Vue | null;
  vessels: Vue[];
}

export interface IFleetMethods {
  registerVessel: (vessel: Vue) => void;
  toggleVessel: (vessel: Vue) => void;
}

@Component
export default class VesselFleet extends Vue {
  // Props

  @Prop({ default: -1 })
  public readonly value!: IFleetData["activeIndex"];

  // Data

  public vessels: IFleetData["vessels"] = [];
  public activeIndex: IFleetData["activeIndex"] = this.value;

  // Computed

  public get activeVessel(): IFleetData["activeVessel"] {
    return this.$_.get(this.vessels, `[${this.activeIndex}]`, null);
  }

  // Provide

  @Provide("fleetData")
  public fleetData(): IFleetData {
    return {
      activeIndex: this.activeIndex,
      activeVessel: this.activeVessel,
      vessels: this.vessels
    };
  }

  @Provide("fleetMethods")
  public get fleetMethods(): IFleetMethods {
    return {
      registerVessel: this.registerVessel,
      toggleVessel: this.toggleVessel
    };
  }

  // Watchers

  @Watch("value")
  public onValueChange(value): void {
    if (value !== this.activeIndex) {
      this.changeVessel(value);
    }
  }

  // Methods

  public registerVessel(vessel): void {
    this.vessels.push(vessel);
  }

  public toggleVessel(vessel): void {
    const newIndex = this.$_.indexOf(this.vessels, vessel);
    this.changeVessel(newIndex);
    if (typeof this.value !== "undefined") {
      this.$emit("input", newIndex);
    }
  }

  public changeVessel(newIndex): void {
    if (this.activeIndex === newIndex) newIndex = -1;
    this.$set(this, "activeIndex", newIndex);
    this.$emit("change", newIndex);
  }
}
